import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';

import { InputNumberModule } from 'primeng/inputnumber';
import { FormsModule } from '@angular/forms';
import { Order, OrderLine, Product, ProductVariant, SearchResult } from '../../../../graphql/generated/generated-types';
import { Subject, debounceTime, takeUntil } from 'rxjs';

@Component({
  selector: 'app-quantity-selector',
  standalone: true,
  imports: [InputNumberModule, FormsModule],
  templateUrl: './quantity-selector.component.html',
  styleUrl: './quantity-selector.component.scss'
})
export class QuantitySelectorComponent implements OnInit, OnDestroy {
  @Input() order: Order;
  @Input() orderLine: OrderLine;
  @Input() searchResult: SearchResult;
  @Input() productVariant!: ProductVariant;
  @Input() loading: boolean;
  @Input() qtyInCart: { [id: string]: number } = {};
  @Input() quantity: number | undefined;

  @Input() smallButtons: boolean = false;
  @Input() darkMode: boolean = false;
  @Input() maxWidth!: number;

  @Input() classess!: string;
  @Input() min!: number;
  @Output() quantityChange = new EventEmitter<number>();
  @Output() quantityChangeForCart = new EventEmitter<{ itemId: string; quantity: number; }>();

  quantityObservable: Subject<number> = new Subject<number>();
  private unsubscribe$ = new Subject<void>();

  public stockLevel!: number;
  
  ngOnInit(): void {
    if(this.orderLine){
      this.stockLevel = this.convertStringToNumber(this.orderLine.productVariant.stockLevel);
    } else if(this.productVariant){
      this.stockLevel = this.convertStringToNumber(this.productVariant.stockLevel);
    }

    this.createQuantityObservable();

  }

  public convertStringToNumber(value: string): number{
    return parseFloat(value);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
  public changeQuantity(qty: string | number | undefined){
    this.quantityChange.emit(Number(qty));
    if(this.orderLine){
      this.quantityChangeForCart.emit({itemId: this.orderLine.id,quantity:Number(qty)})
    }
  }

  private createQuantityObservable(){
    this.quantityObservable.pipe(debounceTime(!this.orderLine ? 0 : 400), takeUntil(this.unsubscribe$)).subscribe(newQuantity => {
      this.changeQuantity(newQuantity)
    })
  }



} 
